var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-resize-sensor',{on:{"~animationstart":function($event){return _vm.update($event)}}},[_c('div',{on:{"scroll":_vm.update}},[_c('div')]),_c('div',{on:{"scroll":_vm.update}},[_c('div')])])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }